module.exports = __webpack_public_path__ + "img/photo1673896265.89a897ed.jpeg";